var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVifly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.560331 7.76664C-0.540801 5.85149 0.119091 3.40631 2.03424 2.30518C3.94939 1.20405 6.39457 1.86394 7.49571 3.77909L16.184 18.8902C17.2851 20.8054 16.6252 23.2505 14.7101 24.3517C12.7949 25.4528 10.3497 24.7929 9.2486 22.8778L0.560331 7.76664Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4784 10.7331C14.4209 8.73516 16.8047 7.87957 18.8027 8.82211C20.8006 9.76466 21.6562 12.1484 20.7137 14.1464L17.0454 21.9223C16.1028 23.9203 13.7191 24.7759 11.7211 23.8333C9.72312 22.8908 8.86753 20.507 9.81008 18.509L13.4784 10.7331Z",
    fill: "#CBD5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1034 4.11548C25.1034 6.32462 23.3126 8.11548 21.1034 8.11548C18.8943 8.11548 17.1034 6.32462 17.1034 4.11548C17.1034 1.90634 18.8943 0.115479 21.1034 0.115479C23.3126 0.115479 25.1034 1.90634 25.1034 4.11548Z",
    fill: "#395BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVifly);
export default __webpack_public_path__ + "static/media/vifly_.6d7d68fdbd734a24dc2484c3f434bb03.svg";
export { ForwardRef as ReactComponent };